import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import { Box, Drawer, IconButton, Typography } from "@mui/material";
import React, { ReactNode } from "react";
import { DrawerHeader } from "../../DrawerHeader";
import * as Styled from "./PageDrawer.styles";

interface IPageDrawerProps {
    open: boolean;
    icon?: ReactNode;
    title: string;
    parentTitle?: string;
    hideBackButton?: boolean;
    fitToContainer?: boolean;
    children: ReactNode;
    onClose: () => void;
}

export const PageDrawer = (props: IPageDrawerProps) => (
    <Drawer open={props.open} onClose={props.onClose} anchor="right" PaperProps={{ sx: { width: "436px" } }}>
        <Box display="flex" flexDirection="column" flexGrow={2} overflow="hidden">
            <DrawerHeader>
                {(!props.parentTitle
                    ? <Box display="flex" justifyContent="space-between" width="100%">
                        <Box display="flex" alignItems="center">
                            {props.icon &&
                                <div style={{ marginRight: "4px" }}>{props.icon}</div>
                            }
                            <Typography variant="h6">{props.title}</Typography>
                        </Box>
                        <IconButton onClick={props.onClose}>
                            <ClearOutlinedIcon />
                        </IconButton>
                    </Box>
                    : <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
                        <Box display="flex" alignItems="center">
                            {!props.hideBackButton &&
                                <Styled.PanelLink onClick={props.onClose}>
                                    <Styled.ArrowIcon />
                                    {props.parentTitle}
                                </Styled.PanelLink>
                            }
                            {props.icon &&
                                <div style={{ marginRight: "4px" }}>{props.icon}</div>
                            }
                            <Typography variant="body1">{props.title}</Typography>
                        </Box>
                        <IconButton onClick={props.onClose}>
                            <ClearOutlinedIcon />
                        </IconButton>
                    </Box>
                )}
            </DrawerHeader>
            <Box sx={{ overflowY: !props.fitToContainer ? "auto" : undefined, height: props.fitToContainer ? "100%" : undefined }}>
                {props.children}
            </Box>
        </Box>
    </Drawer>
);
